module.exports = __webpack_public_path__ + "img/235-tokelau.1f31ec51.svg";